import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import noproduct from "../../component/img/product_not_found.jpeg";

const ServiceMan = ({ checkedCategories, selectedStates }) => {
  const [serviceMen, setServiceMen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);




  // Fetch all service men (default load or when no categories selected)
  const fetchAllServiceMen = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllServiceMan`);
      const allServiceMen = response.data?.data || [];
      setServiceMen(allServiceMen);
      setError(null);
    } catch (err) {
      console.error("Error fetching all service men:", err);
      setError("Failed to load service men.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch filtered service men by selected category IDs
  const fetchFilteredServiceMen = async (categories) => {
    try {
      const categoryParam = categories.join(",");


console.log("categoryParam", categoryParam);
console.log("baseurl", `${baseurl}getServiceTeamByCategory?category_id=${categoryParam}&state=${selectedStates}`);
  console.log("selectedStates", selectedStates);

    
let url = `${baseurl}getServiceTeamByCategory?category_id=${categoryParam}`;

if (selectedStates && selectedStates.length > 0) {
  url += `&state=${selectedStates.join(',')}`;
}

const response = await axios.get(url);

      const filtered = response.data?.data || [];
      setServiceMen(filtered);
      setError(null);
    } catch (err) {
      console.error("Error fetching filtered service men:", err);
      setError("Failed to filter service men.");
    } finally {
      setLoading(false);
    }
  };

  // Effect for loading data
  useEffect(() => {
    setLoading(true);
    if (checkedCategories && checkedCategories.length > 0) {
      fetchFilteredServiceMen(checkedCategories);
    } else {
      fetchAllServiceMen();
    }
  }, [checkedCategories]);

  return (
    <div className="col-md-10">
      <h4 className="product-desc-title">Service Professional / Service Engineers</h4>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center vh-50">
          <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : (
        <div className="row g-2">
          {serviceMen.length > 0 ? (
            serviceMen.map((man) => (
              <div className="col-md-3 col-6" key={man.id}>
                <div className="product-card">
                  <img
                    src={
                      man.profile_image
                        ? `${imageUrl}servicefile/${man.profile_image}`
                        : noproduct
                    }
                    alt={man.name}
                  />
                  <div className="px-2">
                    <div className="text-start">
                    <span className="cntn">Experience: {man.experience} Years</span>
                  </div>
                  <h3>{man.name}</h3>
                   
                  <a href={`/service-man/${man.id}`} className="btn add-to-cart">
                    View Profile
                  </a>
                  </div>
                  
                </div>
              </div>
            ))
          ) : (
            <div className="text-center">
              <img
                src={noproduct}
                className="img-fluid noproductimg"
                alt="No Data Found"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ServiceMan;
